'use client';
import { useTranslation } from '@/hook';
import React, { useState } from 'react';
import DownloadAppBottomSheet from '@/components/download-app-bottom-sheet';
import SylndrButton, {
    IButtonStyled,
} from '@/components/shared/Button/button-styled.component';
import Typography from '@/components/shared/typography/typography.component';
import { useAnalytics } from '@/integrations';
import useAuth from '@/hook/use-auth.hook';
import { IVariant } from '../shared/typography/typography.types';

export const DownloadApp = ({
    deepLink,
    buttonProps,
    className,
    text,
    textVariant,
    source,
}: {
    deepLink?: string | null;
    className?: string;
    buttonProps?: Partial<IButtonStyled>;
    text?: string;
    textVariant?: IVariant;
    source?: string;
}) => {
    const { t } = useTranslation();
    const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
    const { trackEvent } = useAnalytics();
    const { userId, phone: mobileNumber, name: userName, email } = useAuth();
    const openBottomSheet = () => {
        setBottomSheetOpen(true);
    };
    const openApp = () => {
        window.location.href = `sylndrapp://${
            deepLink ? deepLink : 'HomeScreen'
        }`;

        trackEvent('Action: Swift - Apply CTA', {
            userId,
            mobileNumber,
            userName,
            email,
            sourceButton: source,
        });

        setTimeout(() => {
            openBottomSheet();
        }, 500);
    };

    return (
        <>
            <DownloadAppBottomSheet
                open={bottomSheetOpen}
                setOpen={setBottomSheetOpen}
                source={source}
            />
            <SylndrButton
                variant={'outlined'}
                className={`py-2.5 px-4 ${className}`}
                onClick={openApp}
                {...buttonProps}
            >
                <Typography variant={textVariant || 'body2Medium'}>
                    {text ? text : t('Apply Financing with this EMI')}
                </Typography>
            </SylndrButton>
        </>
    );
};
